module.exports = __webpack_public_path__ + "static/img/keshihua2.f44310fd.png";